/**
 * Copyright 2018 Bloomberg LP
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software
 * and associated documentation files (the "Software"), to deal in the Software without restriction,
 * including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all copies or substantial
 * portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
 * NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.temporal = {})));
}(this, (function (exports) { 'use strict';

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var _global = createCommonjsModule(function (module) {
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	});

	var hasOwnProperty = {}.hasOwnProperty;
	var _has = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};

	var _fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};

	// Thank's IE8 for his funny defineProperty
	var _descriptors = !_fails(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});

	var _core = createCommonjsModule(function (module) {
	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	});
	var _core_1 = _core.version;

	var _aFunction = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};

	// optional / simple context binding

	var _ctx = function (fn, that, length) {
	  _aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};

	var _isObject = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

	var _anObject = function (it) {
	  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};

	var document = _global.document;
	// typeof document.createElement is 'object' in old IE
	var is = _isObject(document) && _isObject(document.createElement);
	var _domCreate = function (it) {
	  return is ? document.createElement(it) : {};
	};

	var _ie8DomDefine = !_descriptors && !_fails(function () {
	  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
	});

	// 7.1.1 ToPrimitive(input [, PreferredType])

	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	var _toPrimitive = function (it, S) {
	  if (!_isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};

	var dP = Object.defineProperty;

	var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  _anObject(O);
	  P = _toPrimitive(P, true);
	  _anObject(Attributes);
	  if (_ie8DomDefine) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

	var _objectDp = {
		f: f
	};

	var _propertyDesc = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var _hide = _descriptors ? function (object, key, value) {
	  return _objectDp.f(object, key, _propertyDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && _has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? _ctx(out, _global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	var _export = $export;

	var _redefine = _hide;

	var id = 0;
	var px = Math.random();
	var _uid = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

	var _meta = createCommonjsModule(function (module) {
	var META = _uid('meta');


	var setDesc = _objectDp.f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !_fails(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!_has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!_has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};
	});
	var _meta_1 = _meta.KEY;
	var _meta_2 = _meta.NEED;
	var _meta_3 = _meta.fastKey;
	var _meta_4 = _meta.getWeak;
	var _meta_5 = _meta.onFreeze;

	var _library = true;

	var _shared = createCommonjsModule(function (module) {
	var SHARED = '__core-js_shared__';
	var store = _global[SHARED] || (_global[SHARED] = {});

	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: _core.version,
	  mode: 'pure',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});
	});

	var _wks = createCommonjsModule(function (module) {
	var store = _shared('wks');

	var Symbol = _global.Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
	};

	$exports.store = store;
	});

	var def = _objectDp.f;

	var TAG = _wks('toStringTag');

	var _setToStringTag = function (it, tag, stat) {
	  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};

	var f$1 = _wks;

	var _wksExt = {
		f: f$1
	};

	var defineProperty = _objectDp.f;
	var _wksDefine = function (name) {
	  var $Symbol = _core.Symbol || (_core.Symbol = _library ? {} : _global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: _wksExt.f(name) });
	};

	var toString = {}.toString;

	var _cof = function (it) {
	  return toString.call(it).slice(8, -1);
	};

	// fallback for non-array-like ES3 and non-enumerable old V8 strings

	// eslint-disable-next-line no-prototype-builtins
	var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return _cof(it) == 'String' ? it.split('') : Object(it);
	};

	// 7.2.1 RequireObjectCoercible(argument)
	var _defined = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};

	// to indexed object, toObject with fallback for non-array-like ES3 strings


	var _toIobject = function (it) {
	  return _iobject(_defined(it));
	};

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	var _toInteger = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

	// 7.1.15 ToLength

	var min = Math.min;
	var _toLength = function (it) {
	  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

	var max = Math.max;
	var min$1 = Math.min;
	var _toAbsoluteIndex = function (index, length) {
	  index = _toInteger(index);
	  return index < 0 ? max(index + length, 0) : min$1(index, length);
	};

	// false -> Array#indexOf
	// true  -> Array#includes



	var _arrayIncludes = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = _toIobject($this);
	    var length = _toLength(O.length);
	    var index = _toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

	var shared = _shared('keys');

	var _sharedKey = function (key) {
	  return shared[key] || (shared[key] = _uid(key));
	};

	var arrayIndexOf = _arrayIncludes(false);
	var IE_PROTO = _sharedKey('IE_PROTO');

	var _objectKeysInternal = function (object, names) {
	  var O = _toIobject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (_has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

	// IE 8- don't enum bug keys
	var _enumBugKeys = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)



	var _objectKeys = Object.keys || function keys(O) {
	  return _objectKeysInternal(O, _enumBugKeys);
	};

	var f$2 = Object.getOwnPropertySymbols;

	var _objectGops = {
		f: f$2
	};

	var f$3 = {}.propertyIsEnumerable;

	var _objectPie = {
		f: f$3
	};

	// all enumerable object keys, includes symbols



	var _enumKeys = function (it) {
	  var result = _objectKeys(it);
	  var getSymbols = _objectGops.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = _objectPie.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};

	// 7.2.2 IsArray(argument)

	var _isArray = Array.isArray || function isArray(arg) {
	  return _cof(arg) == 'Array';
	};

	var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
	  _anObject(O);
	  var keys = _objectKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

	var document$1 = _global.document;
	var _html = document$1 && document$1.documentElement;

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



	var IE_PROTO$1 = _sharedKey('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE$1 = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = _domCreate('iframe');
	  var i = _enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  _html.appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
	  return createDict();
	};

	var _objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE$1] = _anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE$1] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO$1] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : _objectDps(result, Properties);
	};

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

	var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

	var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return _objectKeysInternal(O, hiddenKeys);
	};

	var _objectGopn = {
		f: f$4
	};

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

	var gOPN = _objectGopn.f;
	var toString$1 = {}.toString;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};

	var f$5 = function getOwnPropertyNames(it) {
	  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
	};

	var _objectGopnExt = {
		f: f$5
	};

	var gOPD = Object.getOwnPropertyDescriptor;

	var f$6 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = _toIobject(O);
	  P = _toPrimitive(P, true);
	  if (_ie8DomDefine) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
	};

	var _objectGopd = {
		f: f$6
	};

	// ECMAScript 6 symbols shim





	var META = _meta.KEY;



















	var gOPD$1 = _objectGopd.f;
	var dP$1 = _objectDp.f;
	var gOPN$1 = _objectGopnExt.f;
	var $Symbol = _global.Symbol;
	var $JSON = _global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE$2 = 'prototype';
	var HIDDEN = _wks('_hidden');
	var TO_PRIMITIVE = _wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = _shared('symbol-registry');
	var AllSymbols = _shared('symbols');
	var OPSymbols = _shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE$2];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = _global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = _descriptors && _fails(function () {
	  return _objectCreate(dP$1({}, 'a', {
	    get: function () { return dP$1(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD$1(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP$1(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP$1(ObjectProto, key, protoDesc);
	} : dP$1;

	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
	  sym._k = tag;
	  return sym;
	};

	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};

	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  _anObject(it);
	  key = _toPrimitive(key, true);
	  _anObject(D);
	  if (_has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP$1(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  _anObject(it);
	  var keys = _enumKeys(P = _toIobject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = _toPrimitive(key, true));
	  if (this === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
	  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = _toIobject(it);
	  key = _toPrimitive(key, true);
	  if (it === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
	  var D = gOPD$1(it, key);
	  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN$1(_toIobject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};

	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, _propertyDesc(1, value));
	    };
	    if (_descriptors && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
	    return this._k;
	  });

	  _objectGopd.f = $getOwnPropertyDescriptor;
	  _objectDp.f = $defineProperty;
	  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
	  _objectPie.f = $propertyIsEnumerable;
	  _objectGops.f = $getOwnPropertySymbols;

	  if (_descriptors && !_library) {
	    _redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }

	  _wksExt.f = function (name) {
	    return wrap(_wks(name));
	  };
	}

	_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });

	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);

	for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

	_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return _has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});

	_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});

	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!_isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});

	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	_setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	_setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	_setToStringTag(_global.JSON, 'JSON', true);

	var symbol = _core.Symbol;

	/*
	** Copyright (C) 2018 Bloomberg LP. All rights reserved.
	** This code is governed by the license found in the LICENSE file.
	*/

	var zones = {
	  "Europe/Andorra": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Asia/Dubai": {
	    "+04:00": "Gulf Standard Time"
	  },
	  "Asia/Kabul": {
	    "+04:30": "Afghanistan Time"
	  },
	  "America/Antigua": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "America/Anguilla": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Europe/Tirane": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Asia/Yerevan": {
	    "+04:00": "Armenia Standard Time"
	  },
	  "Africa/Luanda": {
	    "+01:00": "West Africa Standard Time"
	  },
	  "Antarctica/Casey": {
	    "+11:00": "Casey Time"
	  },
	  "Antarctica/Davis": {
	    "+07:00": "Davis Time"
	  },
	  "Antarctica/Mawson": {
	    "+05:00": "Mawson Time"
	  },
	  "Antarctica/Palmer": {
	    "-03:00": "GMT-03:00"
	  },
	  "Antarctica/Rothera": {
	    "-03:00": "Rothera Time"
	  },
	  "Antarctica/Syowa": {
	    "+03:00": "Syowa Time"
	  },
	  "Antarctica/Troll": {
	    "+00:00": "Greenwich Mean Time",
	    "+02:00": "GMT+02:00"
	  },
	  "Antarctica/Vostok": {
	    "+06:00": "Vostok Time"
	  },
	  "America/Argentina/Buenos_Aires": {
	    "-03:00": "Argentina Standard Time"
	  },
	  "America/Argentina/Cordoba": {
	    "-03:00": "Argentina Standard Time"
	  },
	  "America/Argentina/Salta": {
	    "-03:00": "Argentina Standard Time"
	  },
	  "America/Argentina/Jujuy": {
	    "-03:00": "Argentina Standard Time"
	  },
	  "America/Argentina/Tucuman": {
	    "-03:00": "Argentina Standard Time"
	  },
	  "America/Argentina/Catamarca": {
	    "-03:00": "Argentina Standard Time"
	  },
	  "America/Argentina/La_Rioja": {
	    "-03:00": "Argentina Standard Time"
	  },
	  "America/Argentina/San_Juan": {
	    "-03:00": "Argentina Standard Time"
	  },
	  "America/Argentina/Mendoza": {
	    "-03:00": "Argentina Standard Time"
	  },
	  "America/Argentina/San_Luis": {
	    "-03:00": "Western Argentina Standard Time"
	  },
	  "America/Argentina/Rio_Gallegos": {
	    "-03:00": "Argentina Standard Time"
	  },
	  "America/Argentina/Ushuaia": {
	    "-03:00": "Argentina Standard Time"
	  },
	  "Pacific/Pago_Pago": {
	    "-11:00": "Samoa Standard Time"
	  },
	  "Europe/Vienna": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Australia/Lord_Howe": {
	    "+11:00": "Lord Howe Daylight Time",
	    "+10:30": "Lord Howe Standard Time"
	  },
	  "Antarctica/Macquarie": {
	    "+11:00": "Macquarie Island Time"
	  },
	  "Australia/Hobart": {
	    "+11:00": "Australian Eastern Daylight Time",
	    "+10:00": "Australian Eastern Standard Time"
	  },
	  "Australia/Currie": {
	    "+11:00": "Australian Eastern Daylight Time",
	    "+10:00": "Australian Eastern Standard Time"
	  },
	  "Australia/Melbourne": {
	    "+11:00": "Australian Eastern Daylight Time",
	    "+10:00": "Australian Eastern Standard Time"
	  },
	  "Australia/Sydney": {
	    "+11:00": "Australian Eastern Daylight Time",
	    "+10:00": "Australian Eastern Standard Time"
	  },
	  "Australia/Broken_Hill": {
	    "+10:30": "Australian Central Daylight Time",
	    "+09:30": "Australian Central Standard Time"
	  },
	  "Australia/Brisbane": {
	    "+10:00": "Australian Eastern Standard Time"
	  },
	  "Australia/Lindeman": {
	    "+10:00": "Australian Eastern Standard Time"
	  },
	  "Australia/Adelaide": {
	    "+10:30": "Australian Central Daylight Time",
	    "+09:30": "Australian Central Standard Time"
	  },
	  "Australia/Darwin": {
	    "+09:30": "Australian Central Standard Time"
	  },
	  "Australia/Perth": {
	    "+08:00": "Australian Western Standard Time"
	  },
	  "Australia/Eucla": {
	    "+08:45": "Australian Central Western Standard Time"
	  },
	  "America/Aruba": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Europe/Mariehamn": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Asia/Baku": {
	    "+04:00": "Azerbaijan Standard Time"
	  },
	  "Europe/Sarajevo": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "America/Barbados": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Asia/Dhaka": {
	    "+06:00": "Bangladesh Standard Time"
	  },
	  "Europe/Brussels": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Africa/Ouagadougou": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "Europe/Sofia": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Asia/Bahrain": {
	    "+03:00": "Arabian Standard Time"
	  },
	  "Africa/Bujumbura": {
	    "+02:00": "Central Africa Time"
	  },
	  "Africa/Porto-Novo": {
	    "+01:00": "West Africa Standard Time"
	  },
	  "America/St_Barthelemy": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Atlantic/Bermuda": {
	    "-04:00": "Atlantic Standard Time",
	    "-03:00": "Atlantic Daylight Time"
	  },
	  "Asia/Brunei": {
	    "+08:00": "Brunei Darussalam Time"
	  },
	  "America/La_Paz": {
	    "-04:00": "Bolivia Time"
	  },
	  "America/Kralendijk": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "America/Noronha": {
	    "-02:00": "Fernando de Noronha Standard Time"
	  },
	  "America/Belem": {
	    "-03:00": "Brasilia Standard Time"
	  },
	  "America/Fortaleza": {
	    "-03:00": "Brasilia Standard Time"
	  },
	  "America/Recife": {
	    "-03:00": "Brasilia Standard Time"
	  },
	  "America/Araguaina": {
	    "-03:00": "Brasilia Standard Time"
	  },
	  "America/Maceio": {
	    "-03:00": "Brasilia Standard Time"
	  },
	  "America/Bahia": {
	    "-03:00": "Brasilia Standard Time"
	  },
	  "America/Sao_Paulo": {
	    "-02:00": "Brasilia Summer Time",
	    "-03:00": "Brasilia Standard Time"
	  },
	  "America/Campo_Grande": {
	    "-03:00": "Amazon Summer Time",
	    "-04:00": "Amazon Standard Time"
	  },
	  "America/Cuiaba": {
	    "-03:00": "Amazon Summer Time",
	    "-04:00": "Amazon Standard Time"
	  },
	  "America/Santarem": {
	    "-03:00": "Brasilia Standard Time"
	  },
	  "America/Porto_Velho": {
	    "-04:00": "Amazon Standard Time"
	  },
	  "America/Boa_Vista": {
	    "-04:00": "Amazon Standard Time"
	  },
	  "America/Manaus": {
	    "-04:00": "Amazon Standard Time"
	  },
	  "America/Eirunepe": {
	    "-05:00": "Acre Standard Time"
	  },
	  "America/Rio_Branco": {
	    "-05:00": "Acre Standard Time"
	  },
	  "America/Nassau": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "Asia/Thimphu": {
	    "+06:00": "Bhutan Time"
	  },
	  "Africa/Gaborone": {
	    "+02:00": "Central Africa Time"
	  },
	  "Europe/Minsk": {
	    "+03:00": "Moscow Standard Time"
	  },
	  "America/Belize": {
	    "-06:00": "Central Standard Time"
	  },
	  "America/St_Johns": {
	    "-03:30": "Newfoundland Standard Time",
	    "-02:30": "Newfoundland Daylight Time"
	  },
	  "America/Halifax": {
	    "-04:00": "Atlantic Standard Time",
	    "-03:00": "Atlantic Daylight Time"
	  },
	  "America/Glace_Bay": {
	    "-04:00": "Atlantic Standard Time",
	    "-03:00": "Atlantic Daylight Time"
	  },
	  "America/Moncton": {
	    "-04:00": "Atlantic Standard Time",
	    "-03:00": "Atlantic Daylight Time"
	  },
	  "America/Goose_Bay": {
	    "-04:00": "Atlantic Standard Time",
	    "-03:00": "Atlantic Daylight Time"
	  },
	  "America/Blanc-Sablon": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "America/Toronto": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Nipigon": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Thunder_Bay": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Iqaluit": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Pangnirtung": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Atikokan": {
	    "-05:00": "Eastern Standard Time"
	  },
	  "America/Winnipeg": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Rainy_River": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Resolute": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Rankin_Inlet": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Regina": {
	    "-06:00": "Central Standard Time"
	  },
	  "America/Swift_Current": {
	    "-06:00": "Central Standard Time"
	  },
	  "America/Edmonton": {
	    "-07:00": "Mountain Standard Time",
	    "-06:00": "Mountain Daylight Time"
	  },
	  "America/Cambridge_Bay": {
	    "-07:00": "Mountain Standard Time",
	    "-06:00": "Mountain Daylight Time"
	  },
	  "America/Yellowknife": {
	    "-07:00": "Mountain Standard Time",
	    "-06:00": "Mountain Daylight Time"
	  },
	  "America/Inuvik": {
	    "-07:00": "Mountain Standard Time",
	    "-06:00": "Mountain Daylight Time"
	  },
	  "America/Creston": {
	    "-07:00": "Mountain Standard Time"
	  },
	  "America/Dawson_Creek": {
	    "-07:00": "Mountain Standard Time"
	  },
	  "America/Fort_Nelson": {
	    "-07:00": "Mountain Standard Time"
	  },
	  "America/Vancouver": {
	    "-08:00": "Pacific Standard Time",
	    "-07:00": "Pacific Daylight Time"
	  },
	  "America/Whitehorse": {
	    "-08:00": "Pacific Standard Time",
	    "-07:00": "Pacific Daylight Time"
	  },
	  "America/Dawson": {
	    "-08:00": "Pacific Standard Time",
	    "-07:00": "Pacific Daylight Time"
	  },
	  "Indian/Cocos": {
	    "+06:30": "Cocos Islands Time"
	  },
	  "Africa/Kinshasa": {
	    "+01:00": "West Africa Standard Time"
	  },
	  "Africa/Lubumbashi": {
	    "+02:00": "Central Africa Time"
	  },
	  "Africa/Bangui": {
	    "+01:00": "West Africa Standard Time"
	  },
	  "Africa/Brazzaville": {
	    "+01:00": "West Africa Standard Time"
	  },
	  "Europe/Zurich": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Africa/Abidjan": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "Pacific/Rarotonga": {
	    "-10:00": "Cook Islands Standard Time"
	  },
	  "America/Santiago": {
	    "-03:00": "Chile Summer Time",
	    "-04:00": "Chile Standard Time"
	  },
	  "America/Punta_Arenas": {
	    "-03:00": "GMT-03:00"
	  },
	  "Pacific/Easter": {
	    "-05:00": "Easter Island Summer Time",
	    "-06:00": "Easter Island Standard Time"
	  },
	  "Africa/Douala": {
	    "+01:00": "West Africa Standard Time"
	  },
	  "Asia/Shanghai": {
	    "+08:00": "China Standard Time"
	  },
	  "Asia/Urumqi": {
	    "+06:00": "GMT+06:00"
	  },
	  "America/Bogota": {
	    "-05:00": "Colombia Standard Time"
	  },
	  "America/Costa_Rica": {
	    "-06:00": "Central Standard Time"
	  },
	  "America/Havana": {
	    "-05:00": "Cuba Standard Time",
	    "-04:00": "Cuba Daylight Time"
	  },
	  "Atlantic/Cape_Verde": {
	    "-01:00": "Cape Verde Standard Time"
	  },
	  "America/Curacao": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Indian/Christmas": {
	    "+07:00": "Christmas Island Time"
	  },
	  "Asia/Nicosia": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Asia/Famagusta": {
	    "+02:00": "GMT+02:00",
	    "+03:00": "GMT+03:00"
	  },
	  "Europe/Prague": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Europe/Berlin": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Europe/Busingen": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Africa/Djibouti": {
	    "+03:00": "East Africa Time"
	  },
	  "Europe/Copenhagen": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "America/Dominica": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "America/Santo_Domingo": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Africa/Algiers": {
	    "+01:00": "Central European Standard Time"
	  },
	  "America/Guayaquil": {
	    "-05:00": "Ecuador Time"
	  },
	  "Pacific/Galapagos": {
	    "-06:00": "Galapagos Time"
	  },
	  "Europe/Tallinn": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Africa/Cairo": {
	    "+02:00": "Eastern European Standard Time"
	  },
	  "Africa/El_Aaiun": {
	    "+00:00": "Western European Standard Time",
	    "+01:00": "Western European Summer Time"
	  },
	  "Africa/Asmara": {
	    "+03:00": "East Africa Time"
	  },
	  "Europe/Madrid": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Africa/Ceuta": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Atlantic/Canary": {
	    "+00:00": "Western European Standard Time",
	    "+01:00": "Western European Summer Time"
	  },
	  "Africa/Addis_Ababa": {
	    "+03:00": "East Africa Time"
	  },
	  "Europe/Helsinki": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Pacific/Fiji": {
	    "+13:00": "Fiji Summer Time",
	    "+12:00": "Fiji Standard Time"
	  },
	  "Atlantic/Stanley": {
	    "-03:00": "Falkland Islands Standard Time"
	  },
	  "Pacific/Chuuk": {
	    "+10:00": "Chuuk Time"
	  },
	  "Pacific/Pohnpei": {
	    "+11:00": "Ponape Time"
	  },
	  "Pacific/Kosrae": {
	    "+11:00": "Kosrae Time"
	  },
	  "Atlantic/Faroe": {
	    "+00:00": "Western European Standard Time",
	    "+01:00": "Western European Summer Time"
	  },
	  "Europe/Paris": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Africa/Libreville": {
	    "+01:00": "West Africa Standard Time"
	  },
	  "Europe/London": {
	    "+00:00": "Greenwich Mean Time",
	    "+01:00": "British Summer Time"
	  },
	  "America/Grenada": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Asia/Tbilisi": {
	    "+04:00": "Georgia Standard Time"
	  },
	  "America/Cayenne": {
	    "-03:00": "French Guiana Time"
	  },
	  "Europe/Guernsey": {
	    "+00:00": "Greenwich Mean Time",
	    "+01:00": "GMT+01:00"
	  },
	  "Africa/Accra": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "Europe/Gibraltar": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "America/Godthab": {
	    "-03:00": "West Greenland Standard Time",
	    "-02:00": "West Greenland Summer Time"
	  },
	  "America/Danmarkshavn": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "America/Scoresbysund": {
	    "-01:00": "East Greenland Standard Time",
	    "+00:00": "East Greenland Summer Time"
	  },
	  "America/Thule": {
	    "-04:00": "Atlantic Standard Time",
	    "-03:00": "Atlantic Daylight Time"
	  },
	  "Africa/Banjul": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "Africa/Conakry": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "America/Guadeloupe": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Africa/Malabo": {
	    "+01:00": "West Africa Standard Time"
	  },
	  "Europe/Athens": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Atlantic/South_Georgia": {
	    "-02:00": "South Georgia Time"
	  },
	  "America/Guatemala": {
	    "-06:00": "Central Standard Time"
	  },
	  "Pacific/Guam": {
	    "+10:00": "Chamorro Standard Time"
	  },
	  "Africa/Bissau": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "America/Guyana": {
	    "-04:00": "Guyana Time"
	  },
	  "Asia/Hong_Kong": {
	    "+08:00": "Hong Kong Standard Time"
	  },
	  "America/Tegucigalpa": {
	    "-06:00": "Central Standard Time"
	  },
	  "Europe/Zagreb": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "America/Port-au-Prince": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "Europe/Budapest": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Asia/Jakarta": {
	    "+07:00": "Western Indonesia Time"
	  },
	  "Asia/Pontianak": {
	    "+07:00": "Western Indonesia Time"
	  },
	  "Asia/Makassar": {
	    "+08:00": "Central Indonesia Time"
	  },
	  "Asia/Jayapura": {
	    "+09:00": "Eastern Indonesia Time"
	  },
	  "Europe/Dublin": {
	    "+00:00": "Greenwich Mean Time",
	    "+01:00": "Irish Standard Time"
	  },
	  "Asia/Jerusalem": {
	    "+02:00": "Israel Standard Time",
	    "+03:00": "Israel Daylight Time"
	  },
	  "Europe/Isle_of_Man": {
	    "+00:00": "Greenwich Mean Time",
	    "+01:00": "GMT+01:00"
	  },
	  "Asia/Kolkata": {
	    "+05:30": "India Standard Time"
	  },
	  "Indian/Chagos": {
	    "+06:00": "Indian Ocean Time"
	  },
	  "Asia/Baghdad": {
	    "+03:00": "Arabian Standard Time"
	  },
	  "Asia/Tehran": {
	    "+03:30": "Iran Standard Time",
	    "+04:30": "Iran Daylight Time"
	  },
	  "Atlantic/Reykjavik": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "Europe/Rome": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Europe/Jersey": {
	    "+00:00": "Greenwich Mean Time",
	    "+01:00": "GMT+01:00"
	  },
	  "America/Jamaica": {
	    "-05:00": "Eastern Standard Time"
	  },
	  "Asia/Amman": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Asia/Tokyo": {
	    "+09:00": "Japan Standard Time"
	  },
	  "Africa/Nairobi": {
	    "+03:00": "East Africa Time"
	  },
	  "Asia/Bishkek": {
	    "+06:00": "Kyrgyzstan Time"
	  },
	  "Asia/Phnom_Penh": {
	    "+07:00": "Indochina Time"
	  },
	  "Pacific/Tarawa": {
	    "+12:00": "Gilbert Islands Time"
	  },
	  "Pacific/Enderbury": {
	    "+13:00": "Phoenix Islands Time"
	  },
	  "Pacific/Kiritimati": {
	    "+14:00": "Line Islands Time"
	  },
	  "Indian/Comoro": {
	    "+03:00": "East Africa Time"
	  },
	  "America/St_Kitts": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Asia/Pyongyang": {
	    "+08:30": "Pyongyang Time"
	  },
	  "Asia/Seoul": {
	    "+09:00": "Korean Standard Time"
	  },
	  "Asia/Kuwait": {
	    "+03:00": "Arabian Standard Time"
	  },
	  "America/Cayman": {
	    "-05:00": "Eastern Standard Time"
	  },
	  "Asia/Almaty": {
	    "+06:00": "East Kazakhstan Time"
	  },
	  "Asia/Qyzylorda": {
	    "+06:00": "East Kazakhstan Time"
	  },
	  "Asia/Aqtobe": {
	    "+05:00": "West Kazakhstan Time"
	  },
	  "Asia/Aqtau": {
	    "+05:00": "West Kazakhstan Time"
	  },
	  "Asia/Atyrau": {
	    "+05:00": "West Kazakhstan Time"
	  },
	  "Asia/Oral": {
	    "+05:00": "West Kazakhstan Time"
	  },
	  "Asia/Vientiane": {
	    "+07:00": "Indochina Time"
	  },
	  "Asia/Beirut": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "America/St_Lucia": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Europe/Vaduz": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Asia/Colombo": {
	    "+05:30": "India Standard Time"
	  },
	  "Africa/Monrovia": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "Africa/Maseru": {
	    "+02:00": "South Africa Standard Time"
	  },
	  "Europe/Vilnius": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Europe/Luxembourg": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Europe/Riga": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Africa/Tripoli": {
	    "+02:00": "Eastern European Standard Time"
	  },
	  "Africa/Casablanca": {
	    "+00:00": "Western European Standard Time",
	    "+01:00": "Western European Summer Time"
	  },
	  "Europe/Monaco": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Europe/Chisinau": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Europe/Podgorica": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "America/Marigot": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Indian/Antananarivo": {
	    "+03:00": "East Africa Time"
	  },
	  "Pacific/Majuro": {
	    "+12:00": "Marshall Islands Time"
	  },
	  "Pacific/Kwajalein": {
	    "+12:00": "Marshall Islands Time"
	  },
	  "Europe/Skopje": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Africa/Bamako": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "Asia/Yangon": {
	    "+06:30": "Myanmar Time"
	  },
	  "Asia/Ulaanbaatar": {
	    "+08:00": "Ulaanbaatar Standard Time"
	  },
	  "Asia/Hovd": {
	    "+07:00": "Hovd Standard Time"
	  },
	  "Asia/Choibalsan": {
	    "+08:00": "Choibalsan Standard Time"
	  },
	  "Asia/Macau": {
	    "+08:00": "China Standard Time"
	  },
	  "Pacific/Saipan": {
	    "+10:00": "Chamorro Standard Time"
	  },
	  "America/Martinique": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Africa/Nouakchott": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "America/Montserrat": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Europe/Malta": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Indian/Mauritius": {
	    "+04:00": "Mauritius Standard Time"
	  },
	  "Indian/Maldives": {
	    "+05:00": "Maldives Time"
	  },
	  "Africa/Blantyre": {
	    "+02:00": "Central Africa Time"
	  },
	  "America/Mexico_City": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Cancun": {
	    "-05:00": "Eastern Standard Time"
	  },
	  "America/Merida": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Monterrey": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Matamoros": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Mazatlan": {
	    "-07:00": "Mexican Pacific Standard Time",
	    "-06:00": "Mexican Pacific Daylight Time"
	  },
	  "America/Chihuahua": {
	    "-07:00": "Mexican Pacific Standard Time",
	    "-06:00": "Mexican Pacific Daylight Time"
	  },
	  "America/Ojinaga": {
	    "-07:00": "Mountain Standard Time",
	    "-06:00": "Mountain Daylight Time"
	  },
	  "America/Hermosillo": {
	    "-07:00": "Mexican Pacific Standard Time"
	  },
	  "America/Tijuana": {
	    "-08:00": "Pacific Standard Time",
	    "-07:00": "Pacific Daylight Time"
	  },
	  "America/Bahia_Banderas": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "Asia/Kuala_Lumpur": {
	    "+08:00": "Malaysia Time"
	  },
	  "Asia/Kuching": {
	    "+08:00": "Malaysia Time"
	  },
	  "Africa/Maputo": {
	    "+02:00": "Central Africa Time"
	  },
	  "Africa/Windhoek": {
	    "+02:00": "Central Africa Time"
	  },
	  "Pacific/Noumea": {
	    "+11:00": "New Caledonia Standard Time"
	  },
	  "Africa/Niamey": {
	    "+01:00": "West Africa Standard Time"
	  },
	  "Pacific/Norfolk": {
	    "+11:00": "Norfolk Island Time"
	  },
	  "Africa/Lagos": {
	    "+01:00": "West Africa Standard Time"
	  },
	  "America/Managua": {
	    "-06:00": "Central Standard Time"
	  },
	  "Europe/Amsterdam": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Europe/Oslo": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Asia/Kathmandu": {
	    "+05:45": "Nepal Time"
	  },
	  "Pacific/Nauru": {
	    "+12:00": "Nauru Time"
	  },
	  "Pacific/Niue": {
	    "-11:00": "Niue Time"
	  },
	  "Pacific/Auckland": {
	    "+13:00": "New Zealand Daylight Time",
	    "+12:00": "New Zealand Standard Time"
	  },
	  "Pacific/Chatham": {
	    "+13:45": "Chatham Daylight Time",
	    "+12:45": "Chatham Standard Time"
	  },
	  "Asia/Muscat": {
	    "+04:00": "Gulf Standard Time"
	  },
	  "America/Panama": {
	    "-05:00": "Eastern Standard Time"
	  },
	  "America/Lima": {
	    "-05:00": "Peru Standard Time"
	  },
	  "Pacific/Tahiti": {
	    "-10:00": "Tahiti Time"
	  },
	  "Pacific/Marquesas": {
	    "-09:30": "Marquesas Time"
	  },
	  "Pacific/Gambier": {
	    "-09:00": "Gambier Time"
	  },
	  "Pacific/Port_Moresby": {
	    "+10:00": "Papua New Guinea Time"
	  },
	  "Pacific/Bougainville": {
	    "+11:00": "GMT+11:00"
	  },
	  "Asia/Manila": {
	    "+08:00": "Philippine Standard Time"
	  },
	  "Asia/Karachi": {
	    "+05:00": "Pakistan Standard Time"
	  },
	  "Europe/Warsaw": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "America/Miquelon": {
	    "-03:00": "St. Pierre & Miquelon Standard Time",
	    "-02:00": "St. Pierre & Miquelon Daylight Time"
	  },
	  "Pacific/Pitcairn": {
	    "-08:00": "Pitcairn Time"
	  },
	  "America/Puerto_Rico": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Asia/Gaza": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Asia/Hebron": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Europe/Lisbon": {
	    "+00:00": "Western European Standard Time",
	    "+01:00": "Western European Summer Time"
	  },
	  "Atlantic/Madeira": {
	    "+00:00": "Western European Standard Time",
	    "+01:00": "Western European Summer Time"
	  },
	  "Atlantic/Azores": {
	    "-01:00": "Azores Standard Time",
	    "+00:00": "Azores Summer Time"
	  },
	  "Pacific/Palau": {
	    "+09:00": "Palau Time"
	  },
	  "America/Asuncion": {
	    "-03:00": "Paraguay Summer Time",
	    "-04:00": "Paraguay Standard Time"
	  },
	  "Asia/Qatar": {
	    "+03:00": "Arabian Standard Time"
	  },
	  "Indian/Reunion": {
	    "+04:00": "Réunion Time"
	  },
	  "Europe/Bucharest": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Europe/Belgrade": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Europe/Kaliningrad": {
	    "+02:00": "Eastern European Standard Time"
	  },
	  "Europe/Moscow": {
	    "+03:00": "Moscow Standard Time"
	  },
	  "Europe/Simferopol": {
	    "+03:00": "Moscow Standard Time"
	  },
	  "Europe/Volgograd": {
	    "+03:00": "Moscow Standard Time"
	  },
	  "Europe/Kirov": {
	    "+03:00": "GMT+03:00"
	  },
	  "Europe/Astrakhan": {
	    "+04:00": "GMT+04:00"
	  },
	  "Europe/Saratov": {
	    "+04:00": "GMT+04:00"
	  },
	  "Europe/Ulyanovsk": {
	    "+04:00": "GMT+04:00"
	  },
	  "Europe/Samara": {
	    "+04:00": "Samara Standard Time"
	  },
	  "Asia/Yekaterinburg": {
	    "+05:00": "Yekaterinburg Standard Time"
	  },
	  "Asia/Omsk": {
	    "+06:00": "Omsk Standard Time"
	  },
	  "Asia/Novosibirsk": {
	    "+07:00": "Novosibirsk Standard Time"
	  },
	  "Asia/Barnaul": {
	    "+07:00": "GMT+07:00"
	  },
	  "Asia/Tomsk": {
	    "+07:00": "GMT+07:00"
	  },
	  "Asia/Novokuznetsk": {
	    "+07:00": "Krasnoyarsk Standard Time"
	  },
	  "Asia/Krasnoyarsk": {
	    "+07:00": "Krasnoyarsk Standard Time"
	  },
	  "Asia/Irkutsk": {
	    "+08:00": "Irkutsk Standard Time"
	  },
	  "Asia/Chita": {
	    "+09:00": "Yakutsk Standard Time"
	  },
	  "Asia/Yakutsk": {
	    "+09:00": "Yakutsk Standard Time"
	  },
	  "Asia/Khandyga": {
	    "+09:00": "Yakutsk Standard Time"
	  },
	  "Asia/Vladivostok": {
	    "+10:00": "Vladivostok Standard Time"
	  },
	  "Asia/Ust-Nera": {
	    "+10:00": "Vladivostok Standard Time"
	  },
	  "Asia/Magadan": {
	    "+11:00": "Magadan Standard Time"
	  },
	  "Asia/Sakhalin": {
	    "+11:00": "Sakhalin Standard Time"
	  },
	  "Asia/Srednekolymsk": {
	    "+11:00": "GMT+11:00"
	  },
	  "Asia/Kamchatka": {
	    "+12:00": "Petropavlovsk-Kamchatski Standard Time"
	  },
	  "Asia/Anadyr": {
	    "+12:00": "Anadyr Standard Time"
	  },
	  "Africa/Kigali": {
	    "+02:00": "Central Africa Time"
	  },
	  "Asia/Riyadh": {
	    "+03:00": "Arabian Standard Time"
	  },
	  "Pacific/Guadalcanal": {
	    "+11:00": "Solomon Islands Time"
	  },
	  "Indian/Mahe": {
	    "+04:00": "Seychelles Time"
	  },
	  "Africa/Khartoum": {
	    "+02:00": "Central Africa Time"
	  },
	  "Europe/Stockholm": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Asia/Singapore": {
	    "+08:00": "Singapore Standard Time"
	  },
	  "Atlantic/St_Helena": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "Europe/Ljubljana": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Arctic/Longyearbyen": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Europe/Bratislava": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Africa/Freetown": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "Europe/San_Marino": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "Africa/Dakar": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "Africa/Mogadishu": {
	    "+03:00": "East Africa Time"
	  },
	  "America/Paramaribo": {
	    "-03:00": "Suriname Time"
	  },
	  "Africa/Juba": {
	    "+03:00": "East Africa Time"
	  },
	  "Africa/Sao_Tome": {
	    "+00:00": "Greenwich Mean Time",
	    "+01:00": "West Africa Standard Time"
	  },
	  "America/El_Salvador": {
	    "-06:00": "Central Standard Time"
	  },
	  "America/Lower_Princes": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Asia/Damascus": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Africa/Mbabane": {
	    "+02:00": "South Africa Standard Time"
	  },
	  "America/Grand_Turk": {
	    "-04:00": "Eastern Daylight Time",
	    "-05:00": "Eastern Standard Time"
	  },
	  "Africa/Ndjamena": {
	    "+01:00": "West Africa Standard Time"
	  },
	  "Indian/Kerguelen": {
	    "+05:00": "French Southern & Antarctic Time"
	  },
	  "Africa/Lome": {
	    "+00:00": "Greenwich Mean Time"
	  },
	  "Asia/Bangkok": {
	    "+07:00": "Indochina Time"
	  },
	  "Asia/Dushanbe": {
	    "+05:00": "Tajikistan Time"
	  },
	  "Pacific/Fakaofo": {
	    "+13:00": "Tokelau Time"
	  },
	  "Asia/Dili": {
	    "+09:00": "East Timor Time"
	  },
	  "Asia/Ashgabat": {
	    "+05:00": "Turkmenistan Standard Time"
	  },
	  "Africa/Tunis": {
	    "+01:00": "Central European Standard Time"
	  },
	  "Pacific/Tongatapu": {
	    "+13:00": "Tonga Standard Time"
	  },
	  "Europe/Istanbul": {
	    "+03:00": "GMT+03:00"
	  },
	  "America/Port_of_Spain": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Pacific/Funafuti": {
	    "+12:00": "Tuvalu Time"
	  },
	  "Asia/Taipei": {
	    "+08:00": "Taipei Standard Time"
	  },
	  "Africa/Dar_es_Salaam": {
	    "+03:00": "East Africa Time"
	  },
	  "Europe/Kiev": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Europe/Uzhgorod": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Europe/Zaporozhye": {
	    "+02:00": "Eastern European Standard Time",
	    "+03:00": "Eastern European Summer Time"
	  },
	  "Africa/Kampala": {
	    "+03:00": "East Africa Time"
	  },
	  "Pacific/Midway": {
	    "-11:00": "Samoa Standard Time"
	  },
	  "Pacific/Wake": {
	    "+12:00": "Wake Island Time"
	  },
	  "America/New_York": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Detroit": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Kentucky/Louisville": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Kentucky/Monticello": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Indiana/Indianapolis": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Indiana/Vincennes": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Indiana/Winamac": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Indiana/Marengo": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Indiana/Petersburg": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Indiana/Vevay": {
	    "-05:00": "Eastern Standard Time",
	    "-04:00": "Eastern Daylight Time"
	  },
	  "America/Chicago": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Indiana/Tell_City": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Indiana/Knox": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Menominee": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/North_Dakota/Center": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/North_Dakota/New_Salem": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/North_Dakota/Beulah": {
	    "-06:00": "Central Standard Time",
	    "-05:00": "Central Daylight Time"
	  },
	  "America/Denver": {
	    "-07:00": "Mountain Standard Time",
	    "-06:00": "Mountain Daylight Time"
	  },
	  "America/Boise": {
	    "-07:00": "Mountain Standard Time",
	    "-06:00": "Mountain Daylight Time"
	  },
	  "America/Phoenix": {
	    "-07:00": "Mountain Standard Time"
	  },
	  "America/Los_Angeles": {
	    "-08:00": "Pacific Standard Time",
	    "-07:00": "Pacific Daylight Time"
	  },
	  "America/Anchorage": {
	    "-09:00": "Alaska Standard Time",
	    "-08:00": "Alaska Daylight Time"
	  },
	  "America/Juneau": {
	    "-09:00": "Alaska Standard Time",
	    "-08:00": "Alaska Daylight Time"
	  },
	  "America/Sitka": {
	    "-09:00": "Alaska Standard Time",
	    "-08:00": "Alaska Daylight Time"
	  },
	  "America/Metlakatla": {
	    "-09:00": "Alaska Standard Time",
	    "-08:00": "Alaska Daylight Time"
	  },
	  "America/Yakutat": {
	    "-09:00": "Alaska Standard Time",
	    "-08:00": "Alaska Daylight Time"
	  },
	  "America/Nome": {
	    "-09:00": "Alaska Standard Time",
	    "-08:00": "Alaska Daylight Time"
	  },
	  "America/Adak": {
	    "-10:00": "Hawaii-Aleutian Standard Time",
	    "-09:00": "Hawaii-Aleutian Daylight Time"
	  },
	  "Pacific/Honolulu": {
	    "-10:00": "Hawaii-Aleutian Standard Time"
	  },
	  "America/Montevideo": {
	    "-03:00": "Uruguay Standard Time"
	  },
	  "Asia/Samarkand": {
	    "+05:00": "Uzbekistan Standard Time"
	  },
	  "Asia/Tashkent": {
	    "+05:00": "Uzbekistan Standard Time"
	  },
	  "Europe/Vatican": {
	    "+01:00": "Central European Standard Time",
	    "+02:00": "Central European Summer Time"
	  },
	  "America/St_Vincent": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "America/Caracas": {
	    "-04:00": "Venezuela Time"
	  },
	  "America/Tortola": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "America/St_Thomas": {
	    "-04:00": "Atlantic Standard Time"
	  },
	  "Asia/Ho_Chi_Minh": {
	    "+07:00": "Indochina Time"
	  },
	  "Pacific/Efate": {
	    "+11:00": "Vanuatu Standard Time"
	  },
	  "Pacific/Wallis": {
	    "+12:00": "Wallis & Futuna Time"
	  },
	  "Pacific/Apia": {
	    "+14:00": "Apia Daylight Time",
	    "+13:00": "Apia Standard Time"
	  },
	  "Asia/Aden": {
	    "+03:00": "Arabian Standard Time"
	  },
	  "Indian/Mayotte": {
	    "+03:00": "East Africa Time"
	  },
	  "Africa/Johannesburg": {
	    "+02:00": "South Africa Standard Time"
	  },
	  "Africa/Lusaka": {
	    "+02:00": "Central Africa Time"
	  },
	  "Africa/Harare": {
	    "+02:00": "Central Africa Time"
	  },
	  "UTC": {
	    "+00:00": "Coordinated Universal Time"
	  },
	  "GMT": {
	    "+00:00": "Coordinated Universal Time"
	  }
	};

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};

	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

	function plus() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$year = _ref.year,
	      ly = _ref$year === undefined ? 0 : _ref$year,
	      _ref$month = _ref.month,
	      lm = _ref$month === undefined ? 0 : _ref$month,
	      _ref$day = _ref.day,
	      ld = _ref$day === undefined ? 0 : _ref$day,
	      _ref$hour = _ref.hour,
	      lhr = _ref$hour === undefined ? 0 : _ref$hour,
	      _ref$minute = _ref.minute,
	      lmn = _ref$minute === undefined ? 0 : _ref$minute,
	      _ref$second = _ref.second,
	      lsd = _ref$second === undefined ? 0 : _ref$second,
	      _ref$millisecond = _ref.millisecond,
	      lms = _ref$millisecond === undefined ? 0 : _ref$millisecond,
	      _ref$nanosecond = _ref.nanosecond,
	      lns = _ref$nanosecond === undefined ? 0 : _ref$nanosecond;

	  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref2$years = _ref2.years,
	      ry = _ref2$years === undefined ? 0 : _ref2$years,
	      _ref2$months = _ref2.months,
	      rm = _ref2$months === undefined ? 0 : _ref2$months,
	      _ref2$days = _ref2.days,
	      rd = _ref2$days === undefined ? 0 : _ref2$days,
	      _ref2$hours = _ref2.hours,
	      rhr = _ref2$hours === undefined ? 0 : _ref2$hours,
	      _ref2$minutes = _ref2.minutes,
	      rmn = _ref2$minutes === undefined ? 0 : _ref2$minutes,
	      _ref2$seconds = _ref2.seconds,
	      rsd = _ref2$seconds === undefined ? 0 : _ref2$seconds,
	      _ref2$milliseconds = _ref2.milliseconds,
	      rms = _ref2$milliseconds === undefined ? 0 : _ref2$milliseconds,
	      _ref2$nanoseconds = _ref2.nanoseconds,
	      rns = _ref2$nanoseconds === undefined ? 0 : _ref2$nanoseconds;

	  var year = ly + ry;
	  var month = lm + rm;
	  var day = ld + rd;
	  var hour = lhr + rhr;
	  var minute = lmn + rmn;
	  var second = lsd + rsd;
	  var millisecond = lms + rms;
	  var nanosecond = lns + rns;

	  while (nanosecond < 0) {
	    nanosecond += 1E6;
	    millisecond -= 1;
	  }
	  while (nanosecond >= 1E6) {
	    nanosecond -= 1E6;
	    millisecond += 1;
	  }

	  var date = new Date(Date.UTC(year, month - 1, day, hour, minute, second, millisecond));

	  return {
	    year: date.getUTCFullYear(),
	    month: date.getUTCMonth() + 1,
	    day: date.getUTCDate(),
	    hour: date.getUTCHours(),
	    minute: date.getUTCMinutes(),
	    second: date.getUTCSeconds(),
	    millisecond: date.getUTCMilliseconds(),
	    nanosecond: nanosecond
	  };
	}
	function pad(num, cnt) {
	  return ('0000000000' + ('' + num).trim()).slice(-1 * cnt);
	}
	var systemZone = void 0;
	function systemTimeZone() {
	  if (systemZone) {
	    return systemZone;
	  }
	  var zone = new Intl.DateTimeFormat('en-us', { timeZoneName: 'long' }).formatToParts().find(function (i) {
	    return i.type === 'timeZoneName';
	  });
	  if (zones[zone.value]) {
	    return zone.value;
	  }
	  var iana = Object.keys(zones);

	  var _loop = function _loop(iananame) {
	    var data = zones[iananame];
	    if (Object.keys(data).find(function (off) {
	      return data[off] === zone.value;
	    })) {
	      return {
	        v: systemZone = iananame
	      };
	    }  };

	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;

	  try {
	    for (var _iterator = iana[symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var iananame = _step.value;

	      var _ret = _loop(iananame);

	      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }

	  var offset = new Date().getTimezoneOffset();
	  var sign = offset < 0 ? '-' : '+';
	  var hours = ('00' + Math.floor(Math.abs(offset) / 60)).slice(-2);
	  var minutes = ('00' + Math.floor(Math.abs(offset) % 60)).slice(-2);
	  var short = '' + sign + hours + ':' + minutes;

	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;

	  try {
	    for (var _iterator2 = iana[symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var iananame = _step2.value;

	      var _data = iana[iananame];
	      if (_data[short]) {
	        return iananame;
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }

	  return short;
	}
	function findTimeZone(offset) {
	  var base = Math.abs(Math.floor(offset / 60000));
	  var hours = ('00' + Math.floor(base / 60)).slice(-2);
	  var minutes = ('00' + base % 60).slice(-2);
	  var string = '' + (offset < 0 ? '-' : '+') + hours + ':' + minutes;

	  var iana = Object.keys(zones);
	  var _iteratorNormalCompletion3 = true;
	  var _didIteratorError3 = false;
	  var _iteratorError3 = undefined;

	  try {
	    for (var _iterator3 = iana[symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	      var iananame = _step3.value;

	      var _data2 = zones[iananame];
	      if (_data2[string]) return iananame;
	    }
	  } catch (err) {
	    _didIteratorError3 = true;
	    _iteratorError3 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion3 && _iterator3.return) {
	        _iterator3.return();
	      }
	    } finally {
	      if (_didIteratorError3) {
	        throw _iteratorError3;
	      }
	    }
	  }

	  return undefined;
	}

	function validZone(zone) {
	  zone = zone === 'SYSTEM' ? systemTimeZone() : zone;
	  if (!!zones[zone]) {
	    return zone;
	  }
	  var match = /([+-])?(\d{1,2})(:?(\d{1,2}))?/.exec(zone);
	  if (!match) throw new TypeError('Invalid Time-Zone: ' + zone);
	  var sign = match[1] || '+';
	  var hours = ('00' + match[2]).slice(-2);
	  var minutes = ('00' + (mathc[3] || '')).slice(-2);
	  return '' + sign + hours + ':{$minutes}';
	}

	var parseExpression = function () {
	  var date = '(\\d{4})-(\\d{2})-(\\d{2})';
	  var time = '(\\d{2}):(\\d{2}):(\\d{2})(?:\\.(\\d{3,9}))?';
	  var offs = '([+-]?\\d{1,2}(?::?\\d{2})?)';
	  var zone = '(?:\\[(\\w+\/\\w+|UTC)\\])';
	  return new RegExp('^' + date + 'T' + time + offs + '?' + zone + '?$');
	}();
	var parseOffset = function parseOffset(str) {
	  if (!str) return undefined;
	  var match = /([+-]?\d{1,2}):?(\d{2})?/.exec(str) || [null, '0', '0'];
	  var hour = match[1] || '0';
	  var mins = match[2] || '0';
	  return (+hour * 60 + +mins) * 60000;
	};

	function parse(str) {
	  var match = parseExpression.exec(str) || [];
	  var year = +match[1];
	  var month = +match[2];
	  var day = +match[3];
	  var hour = +match[4];
	  var minute = +match[5];
	  var second = +match[6];
	  var subsec = +((isNaN(+match[7]) ? 0 : +match[7]) + '000000000').slice(0, 9).replace(/^0+/, '');

	  var millisecond = Math.floor(subsec / 1e6);
	  var nanosecond = subsec % 1e6;

	  var offset = parseOffset(match[8]);
	  var zone = match[9] || findTimeZone(offset) || systemTimeZone();

	  return {
	    year: year, month: month, day: day,
	    hour: hour, minute: minute, second: second,
	    millisecond: millisecond, nanosecond: nanosecond,
	    offset: offset, zone: zone
	  };
	}

	/*
	** Copyright (C) 2018 Bloomberg LP. All rights reserved.
	** This code is governed by the license found in the LICENSE file.
	*/

	function toEpoch() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$year = _ref.year,
	      year = _ref$year === undefined ? 1970 : _ref$year,
	      _ref$month = _ref.month,
	      month = _ref$month === undefined ? 1 : _ref$month,
	      _ref$day = _ref.day,
	      day = _ref$day === undefined ? 1 : _ref$day,
	      _ref$hour = _ref.hour,
	      hour = _ref$hour === undefined ? 0 : _ref$hour,
	      _ref$minute = _ref.minute,
	      minute = _ref$minute === undefined ? 0 : _ref$minute,
	      _ref$second = _ref.second,
	      second = _ref$second === undefined ? 0 : _ref$second,
	      _ref$millisecond = _ref.millisecond,
	      millisecond = _ref$millisecond === undefined ? 0 : _ref$millisecond;

	  var zone = arguments[1];

	  var ts = Date.UTC(year, month - 1, day, hour, minute, second, millisecond);

	  var offsetI = guessOffset(ts, zone);

	  var offsetA = guessOffset(ts + offsetI, zone);
	  if (checkOffset(ts + offsetA, zone, { year: year, month: month, day: day, hour: hour, minute: minute, second: second, millisecond: millisecond })) {
	    return ts + offsetA;
	  }

	  var offsetB = guessOffset(ts - offsetI, zone);
	  if (checkOffset(ts + offsetB, zone, { year: year, month: month, day: day, hour: hour, minute: minute, second: second, millisecond: millisecond })) {
	    return ts + offsetB;
	  }

	  return ts + Math.min(offsetA, offsetB);
	}

	function fromEpoch() {
	  var ts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var zone = arguments[1];

	  var date = new Date(ts);
	  var fmt = formatter(zone);

	  var _fmt$formatToParts$re = fmt.formatToParts(date).reduce(function (res, item) {
	    if (item.type !== 'literal') res[item.type] = parseInt(item.value, 10);
	    return res;
	  }, {}),
	      year = _fmt$formatToParts$re.year,
	      month = _fmt$formatToParts$re.month,
	      day = _fmt$formatToParts$re.day,
	      hour = _fmt$formatToParts$re.hour,
	      minute = _fmt$formatToParts$re.minute,
	      second = _fmt$formatToParts$re.second;

	  return {
	    year: year, month: month, day: day,
	    hour: hour, minute: minute, second: second,
	    millisecond: date.getUTCMilliseconds()
	  };
	}

	function zoneOffset(ts, zone) {
	  var offset = Math.floor(guessOffset(ts, zone) / 60000);
	  var sign = offset <= 0 ? '+' : '-';
	  var hours = ('00' + Math.floor(Math.abs(offset) / 60)).slice(-2);
	  var minutes = ('00' + Math.abs(offset % 60)).slice(-2);

	  return '' + sign + hours + ':' + minutes;
	}

	function guessOffset(ts, zone) {
	  var offset = fromEpoch(ts, zone);
	  var zoned = Date.UTC(offset.year, offset.month - 1, offset.day, offset.hour, offset.minute, offset.second, ts % 1000);
	  return ts - zoned;
	}

	function checkOffset(ts, zone, _ref2) {
	  var year = _ref2.year,
	      month = _ref2.month,
	      day = _ref2.day,
	      hour = _ref2.hour,
	      minute = _ref2.minute,
	      second = _ref2.second,
	      millisecond = _ref2.millisecond;

	  var parts = fromEpoch(ts, zone);
	  return year === parts.year && month === parts.month && day === parts.day && hour === parts.hour && minute === parts.minute && second === parts.second && millisecond === parts.millisecond;
	}

	function formatter(zone) {
	  if (zone === 'SYSTEM') {
	    return {
	      formatToParts: function formatToParts(date) {
	        return [{ type: 'year', value: '' + r.getFullYear() }, { type: 'literal', value: '-' }, { type: 'month', value: '' + (r.getMonth() + 1) }, { type: 'literal', value: '-' }, { type: 'day', value: '' + r.getDate() }, { type: 'literal', value: ' ' }, { type: 'hour', value: '' + r.getHours() }, { type: 'literal', value: ':' }, { type: 'minute', value: '' + r.getMinutes() }, { type: 'literal', value: ':' }, { type: 'second', value: '' + r.getSeconds() }];
	      }
	    };
	  }
	  var parts = /([+-])(\d{1,2})(?::?(\d{2}))?/.exec(zone);
	  if (parts) {
	    var minutes = +parts[2] * 60 + (parts[3] || 0);
	    var offset = parts[1] === '-' ? -minutes : +minutes;
	    return {
	      formatToParts: function formatToParts(date) {
	        var ts = date.valueOf() - offset;
	        var r = new Date(ts);
	        return [{ type: 'year', value: '' + r.getUTCFullYear() }, { type: 'literal', value: '-' }, { type: 'month', value: '' + (r.getUTCMonth() + 1) }, { type: 'literal', value: '-' }, { type: 'day', value: '' + r.getUTCDate() }, { type: 'literal', value: ' ' }, { type: 'hour', value: '' + r.getUTCHours() }, { type: 'literal', value: ':' }, { type: 'minute', value: '' + r.getUTCMinutes() }, { type: 'literal', value: ':' }, { type: 'second', value: '' + r.getUTCSeconds() }];
	      }
	    };
	  }
	  return new Intl.DateTimeFormat('en-iso', {
	    year: 'numeric',
	    month: 'numeric',
	    day: 'numeric',
	    hour: 'numeric',
	    minute: 'numeric',
	    second: 'numeric',
	    hour12: false,
	    timeZone: zone
	  });
	}

	var DATA = symbol('data');

	var CivilTime = function () {
	  function CivilTime(hours, minutes) {
	    var seconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var milliseconds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	    var nanoseconds = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	    classCallCheck(this, CivilTime);

	    var _plus2 = plus({}, { hours: hours, minutes: minutes, seconds: seconds, milliseconds: milliseconds, nanoseconds: nanoseconds }),
	        hour = _plus2.hour,
	        minute = _plus2.minute,
	        second = _plus2.second,
	        millisecond = _plus2.millisecond,
	        nanosecond = _plus2.nanosecond;

	    this[DATA] = { hour: hour, minute: minute, second: second, millisecond: millisecond, nanosecond: nanosecond };
	  }

	  createClass(CivilTime, [{
	    key: 'plus',
	    value: function plus$$1(data) {
	      var _plus3 = plus(this, data),
	          hour = _plus3.hour,
	          minute = _plus3.minute,
	          second = _plus3.second,
	          millisecond = _plus3.millisecond,
	          nanosecond = _plus3.nanosecond;

	      return new CivilTime(hour, minute, second, millisecond, nanosecond);
	    }
	  }, {
	    key: 'with',
	    value: function _with() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$hour = _ref.hour,
	          hour = _ref$hour === undefined ? this.hour : _ref$hour,
	          _ref$minute = _ref.minute,
	          minute = _ref$minute === undefined ? this.minute : _ref$minute,
	          _ref$second = _ref.second,
	          second = _ref$second === undefined ? this.second : _ref$second,
	          _ref$millisecond = _ref.millisecond,
	          millisecond = _ref$millisecond === undefined ? this.millisecond : _ref$millisecond,
	          _ref$nanosecond = _ref.nanosecond,
	          nanosecond = _ref$nanosecond === undefined ? this.nanosecond : _ref$nanosecond;

	      return new CivilTime(hour, minute, second, millisecond, nanosecond);
	    }
	  }, {
	    key: 'withDate',
	    value: function withDate() {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CivilDateTime.now().toCivilDate();

	      return new CivilDateTime.from(date, this);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var hour = this.hour,
	          minute = this.minute,
	          second = this.second,
	          millisecond = this.millisecond,
	          nanosecond = this.nanosecond;

	      var nanos = millisecond * 1E6 + nanosecond;
	      return pad(hour, 2) + ':' + pad(minute, 2) + ':' + pad(second, 2) + '.' + pad(nanos, 9);
	    }
	  }, {
	    key: 'toDate',
	    value: function toDate(zone, date) {
	      return this.withDate(date).withZone(zone).toDate();
	    }
	  }, {
	    key: 'hour',
	    get: function get$$1() {
	      return this[DATA].hour;
	    }
	  }, {
	    key: 'minute',
	    get: function get$$1() {
	      return this[DATA].minute;
	    }
	  }, {
	    key: 'second',
	    get: function get$$1() {
	      return this[DATA].second;
	    }
	  }, {
	    key: 'millisecond',
	    get: function get$$1() {
	      return this[DATA].millisecond;
	    }
	  }, {
	    key: 'nanosecond',
	    get: function get$$1() {
	      return this[DATA].nanosecond;
	    }
	  }], [{
	    key: 'now',
	    value: function now(zone) {
	      return CivilDateTime.now(zone).toCivilTime();
	    }
	  }, {
	    key: 'fromDate',
	    value: function fromDate(date, zone) {
	      return CivilDateTime.fromDate(date, zone).toCivilTime();
	    }
	  }, {
	    key: 'parse',
	    value: function parse$$1(string) {
	      return CivilDateTime.parse(string).toCivilTime();
	    }
	  }]);
	  return CivilTime;
	}();

	var INSTANT = symbol('instant');
	var ZONE = symbol('zone');

	var ZonedInstant = function () {
	  function ZonedInstant(instant) {
	    var zone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SYSTEM';
	    classCallCheck(this, ZonedInstant);

	    zone = validZone(zone);
	    this[INSTANT] = instant;
	    this[ZONE] = zone;
	  }

	  createClass(ZonedInstant, [{
	    key: 'toCivilDateTime',
	    value: function toCivilDateTime() {
	      var _fromEpoch = fromEpoch(this[INSTANT].milliseconds, this[ZONE]),
	          year = _fromEpoch.year,
	          month = _fromEpoch.month,
	          day = _fromEpoch.day,
	          hour = _fromEpoch.hour,
	          minute = _fromEpoch.minute,
	          second = _fromEpoch.second,
	          millisecond = _fromEpoch.millisecond;

	      var nanosecond = this[INSTANT].nanoseconds;
	      return new CivilDateTime(year, month, day, hour, minute, second, millisecond, nanosecond);
	    }
	  }, {
	    key: 'toCivilTime',
	    value: function toCivilTime() {
	      var _fromEpoch2 = fromEpoch(this[INSTANT].milliseconds, this[ZONE]),
	          hour = _fromEpoch2.hour,
	          minute = _fromEpoch2.minute,
	          second = _fromEpoch2.second,
	          millisecond = _fromEpoch2.millisecond;

	      var nanosecond = this[INSTANT].nanoseconds;
	      return new CivilTime(hour, minute, second, millisecond, nanosecond);
	    }
	  }, {
	    key: 'toCivilDate',
	    value: function toCivilDate() {
	      var _fromEpoch3 = fromEpoch(this[INSTANT].milliseconds, this[ZONE]),
	          year = _fromEpoch3.year,
	          month = _fromEpoch3.month,
	          day = _fromEpoch3.day;

	      return new CivilDate(year, month, day);
	    }
	  }, {
	    key: 'toInstant',
	    value: function toInstant() {
	      return this[INSTANT];
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var ts = this[INSTANT].milliseconds;

	      var _fromEpoch4 = fromEpoch(ts, this[ZONE]),
	          year = _fromEpoch4.year,
	          month = _fromEpoch4.month,
	          day = _fromEpoch4.day,
	          hour = _fromEpoch4.hour,
	          minute = _fromEpoch4.minute,
	          second = _fromEpoch4.second,
	          millisecond = _fromEpoch4.millisecond;

	      var nanosecond = millisecond * 1e6 + this[INSTANT].nanoseconds;
	      var offset = zoneOffset(ts, this[ZONE]);
	      var zone = this[ZONE].indexOf('/') > -1 || this[ZONE] === 'UTC' ? '[' + this[ZONE] + ']' : '';
	      return pad(year, 4) + '-' + pad(month, 2) + '-' + pad(day, 2) + 'T' + pad(hour, 2) + ':' + pad(minute, 2) + ':' + pad(second, 2) + '.' + pad(nanosecond, 9) + offset + zone;
	    }
	  }, {
	    key: 'toDate',
	    value: function toDate() {
	      return this.toInstant().toDate();
	    }
	  }, {
	    key: 'valueOf',
	    value: function valueOf() {
	      return this.toInstant().valueOf();
	    }
	  }, {
	    key: 'format',
	    value: function format() {
	      var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.language;
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var fmt = new Intl.DateTimeFormat(locale, Object.assign({}, options, { timeZone: this.timeZone }));
	      return fmt.format(this.toDate());
	    }
	  }, {
	    key: 'milliseconds',
	    get: function get$$1() {
	      return this[INSTANT].milliseconds;
	    }
	  }, {
	    key: 'nanoseconds',
	    get: function get$$1() {
	      return this[INSTANT].nanoseconds;
	    }
	  }, {
	    key: 'timeZone',
	    get: function get$$1() {
	      return this[ZONE];
	    }
	  }], [{
	    key: 'now',
	    value: function now(zone) {
	      return Instant.now().withZone(zone);
	    }
	  }, {
	    key: 'fromDate',
	    value: function fromDate(date, zone) {
	      return Instant.fromDate(date).withZone(zone);
	    }
	  }, {
	    key: 'parse',
	    value: function parse$$1(string) {
	      var _parse2 = parse(string),
	          year = _parse2.year,
	          month = _parse2.month,
	          day = _parse2.day,
	          hour = _parse2.hour,
	          minute = _parse2.minute,
	          second = _parse2.second,
	          millisecond = _parse2.millisecond,
	          nanosecond = _parse2.nanosecond,
	          zone = _parse2.zone;

	      var civil = new CivilDateTime(year, month, day, hour, minute, second, millisecond, nanosecond);
	      return civil.withZone(zone);
	    }
	  }]);
	  return ZonedInstant;
	}();

	var VALUE = symbol('value');

	var Instant$1 = function () {
	  function Instant() {
	    var nanos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    classCallCheck(this, Instant);

	    if ('bigint' !== typeof nanos) {
	      nanos = BigInt(nanos);
	    }
	    var milliseconds = Number(nanos / BigInt(1e6));
	    var nanoseconds = Number(nanos % BigInt(1e6));
	    this[VALUE] = { milliseconds: milliseconds, nanoseconds: nanoseconds };
	  }

	  createClass(Instant, [{
	    key: 'plus',
	    value: function plus$$1(data) {
	      var object = Object.create(Instant.prototype);
	      object[VALUE] = fromParts(plus(toParts(this[VALUE]), data));
	      return object;
	    }
	  }, {
	    key: 'withZone',
	    value: function withZone(zone) {
	      return new ZonedInstant(this, zone);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.withZone('UTC').toString();
	    }
	  }, {
	    key: 'toDate',
	    value: function toDate() {
	      return new Date(this.milliseconds);
	    }
	  }, {
	    key: 'valueOf',
	    value: function valueOf() {
	      return BigInt(this[VALUE].milliseconds) * BigInt(1e6) + BigInt(this[VALUE].nanoseconds);
	    }
	  }, {
	    key: 'format',
	    value: function format(locale, options) {
	      return this.withZone().format(locale, options);
	    }
	  }, {
	    key: 'milliseconds',
	    get: function get$$1() {
	      return this[VALUE].milliseconds;
	    }
	  }, {
	    key: 'nanoseconds',
	    get: function get$$1() {
	      return this[VALUE].nanoseconds;
	    }
	  }], [{
	    key: 'now',
	    value: function now() {
	      var object = Object.create(Instant.prototype);
	      object[VALUE] = {
	        milliseconds: Date.now(),
	        nanoseconds: 0
	      };
	      return object;
	    }
	  }, {
	    key: 'fromDate',
	    value: function fromDate(date) {
	      var object = Object.create(Instant.prototype);
	      object[VALUE] = {
	        milliseconds: (date || 0).valueOf(),
	        nanoseconds: 0
	      };
	      return object;
	    }
	  }, {
	    key: 'parse',
	    value: function parse$$1(string) {
	      return ZonedInstant.parse(string).toInstant();
	    }
	  }]);
	  return Instant;
	}();

	function toParts(value) {
	  var millis = value.milliseconds;
	  var date = new Date(millis);
	  var year = date.getUTCFullYear();
	  var month = date.getUTCMonth() + 1;
	  var day = date.getUTCDate();
	  var hour = date.getUTCHours();
	  var minute = date.getUTCMinutes();
	  var second = date.getUTCSeconds();
	  var millisecond = date.getUTCMilliseconds();
	  var nanosecond = value.nanoseconds;
	  return { year: year, month: month, day: day, hour: hour, minute: minute, second: second, millisecond: millisecond, nanosecond: nanosecond };
	}
	function fromParts(_ref) {
	  var _ref$year = _ref.year,
	      year = _ref$year === undefined ? 0 : _ref$year,
	      _ref$month = _ref.month,
	      month = _ref$month === undefined ? 1 : _ref$month,
	      _ref$day = _ref.day,
	      day = _ref$day === undefined ? 1 : _ref$day,
	      _ref$hour = _ref.hour,
	      hour = _ref$hour === undefined ? 0 : _ref$hour,
	      _ref$minute = _ref.minute,
	      minute = _ref$minute === undefined ? 0 : _ref$minute,
	      _ref$second = _ref.second,
	      second = _ref$second === undefined ? 0 : _ref$second,
	      _ref$millisecond = _ref.millisecond,
	      millisecond = _ref$millisecond === undefined ? 0 : _ref$millisecond,
	      _ref$nanoseconds = _ref.nanoseconds,
	      nanoseconds = _ref$nanoseconds === undefined ? 0 : _ref$nanoseconds;

	  var milliseconds = Date.UTC(year, month - 1, day, hour, minute, second, millisecond);
	  return { milliseconds: milliseconds, nanoseconds: nanoseconds };
	}

	var DATA$1 = symbol('data');

	var CivilDateTime = function () {
	  function CivilDateTime(years, months, days, hours, minutes) {
	    var seconds = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	    var milliseconds = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	    var nanoseconds = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
	    classCallCheck(this, CivilDateTime);

	    this[DATA$1] = plus({}, { years: years, months: months, days: days, hours: hours, minutes: minutes, seconds: seconds, milliseconds: milliseconds, nanoseconds: nanoseconds });
	  }

	  createClass(CivilDateTime, [{
	    key: 'plus',
	    value: function plus$$1(data) {
	      var _plus2 = plus(this, data),
	          year = _plus2.year,
	          month = _plus2.month,
	          day = _plus2.day,
	          hour = _plus2.hour,
	          minute = _plus2.minute,
	          second = _plus2.second,
	          millisecond = _plus2.millisecond,
	          nanosecond = _plus2.nanosecond;

	      return new CivilDateTime(year, month, day, hour, minute, second, millisecond, nanosecond);
	    }
	  }, {
	    key: 'with',
	    value: function _with() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$year = _ref.year,
	          year = _ref$year === undefined ? this.year : _ref$year,
	          _ref$month = _ref.month,
	          month = _ref$month === undefined ? this.month : _ref$month,
	          _ref$day = _ref.day,
	          day = _ref$day === undefined ? this.day : _ref$day,
	          _ref$hour = _ref.hour,
	          hour = _ref$hour === undefined ? this.hour : _ref$hour,
	          _ref$minute = _ref.minute,
	          minute = _ref$minute === undefined ? this.minute : _ref$minute,
	          _ref$second = _ref.second,
	          second = _ref$second === undefined ? this.second : _ref$second,
	          _ref$millisecond = _ref.millisecond,
	          millisecond = _ref$millisecond === undefined ? this.millisecond : _ref$millisecond,
	          _ref$nanosecond = _ref.nanosecond,
	          nanosecond = _ref$nanosecond === undefined ? this.nanosecond : _ref$nanosecond;

	      return new CivilDateTime(year, month, day, hour, minute, second, millisecond, nanosecond);
	    }
	  }, {
	    key: 'toCivilDate',
	    value: function toCivilDate() {
	      var year = this.year,
	          month = this.month,
	          day = this.day;

	      return new CivilDate(year, month, day);
	    }
	  }, {
	    key: 'toCivilTime',
	    value: function toCivilTime() {
	      var hour = this.hour,
	          minute = this.minute,
	          second = this.second,
	          millisecond = this.millisecond,
	          nanosecond = this.nanosecond;

	      return new CivilTime(hour, minute, second, millisecond, nanosecond);
	    }
	  }, {
	    key: 'withZone',
	    value: function withZone(zone) {
	      var milliseconds = toEpoch(this, zone);
	      var nanoseconds = this.nanosecond;
	      var instant = Object.create(Instant$1.prototype);
	      instant[VALUE] = { milliseconds: milliseconds, nanoseconds: nanoseconds };
	      return new ZonedInstant(instant, zone);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var year = this.year,
	          month = this.month,
	          day = this.day,
	          hour = this.hour,
	          minute = this.minute,
	          second = this.second,
	          millisecond = this.millisecond,
	          nanosecond = this.nanosecond;

	      var nanos = millisecond * 1E6 + nanosecond;
	      return pad(year, 4) + '-' + pad(month, 2) + '-' + pad(day, 2) + 'T' + pad(hour, 2) + ':' + pad(minute, 2) + ':' + pad(second, 2) + '.' + pad(nanos, 9);
	    }
	  }, {
	    key: 'toDate',
	    value: function toDate(zone) {
	      return this.withZone(zone).toDate();
	    }
	  }, {
	    key: 'year',
	    get: function get$$1() {
	      return this[DATA$1].year;
	    }
	  }, {
	    key: 'month',
	    get: function get$$1() {
	      return this[DATA$1].month;
	    }
	  }, {
	    key: 'day',
	    get: function get$$1() {
	      return this[DATA$1].day;
	    }
	  }, {
	    key: 'hour',
	    get: function get$$1() {
	      return this[DATA$1].hour;
	    }
	  }, {
	    key: 'minute',
	    get: function get$$1() {
	      return this[DATA$1].minute;
	    }
	  }, {
	    key: 'second',
	    get: function get$$1() {
	      return this[DATA$1].second;
	    }
	  }, {
	    key: 'millisecond',
	    get: function get$$1() {
	      return this[DATA$1].millisecond;
	    }
	  }, {
	    key: 'nanosecond',
	    get: function get$$1() {
	      return this[DATA$1].nanosecond;
	    }
	  }], [{
	    key: 'from',
	    value: function from() {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var year = date.year,
	          month = date.month,
	          day = date.day;
	      var hour = time.hour,
	          minute = time.minute,
	          second = time.second,
	          millisecond = time.millisecond,
	          nanosecond = time.nanosecond;

	      return new CivilDateTime(year, month, day, hour, minute, second, millisecond, nanosecond);
	    }
	  }, {
	    key: 'now',
	    value: function now(zone) {
	      return ZonedInstant.now(zone).toCivilDateTime();
	    }
	  }, {
	    key: 'fromDate',
	    value: function fromDate(date, zone) {
	      return ZonedInstant.fromDate(date, zone).toCivilDateTime();
	    }
	  }, {
	    key: 'parse',
	    value: function parse$$1(string) {
	      var _parse2 = parse(string),
	          year = _parse2.year,
	          month = _parse2.month,
	          day = _parse2.day,
	          hour = _parse2.hour,
	          minute = _parse2.minute,
	          second = _parse2.second,
	          millisecond = _parse2.millisecond,
	          nanosecond = _parse2.nanosecond;

	      return new CivilDateTime(year, month, day, hour, minute, second, millisecond, nanosecond);
	    }
	  }]);
	  return CivilDateTime;
	}();

	var DATA$2 = symbol('data');

	var CivilDate = function () {
	  function CivilDate(years, months, days) {
	    classCallCheck(this, CivilDate);

	    var _plus2 = plus({}, { years: years, months: months, days: days }),
	        year = _plus2.year,
	        month = _plus2.month,
	        day = _plus2.day;

	    this[DATA$2] = { year: year, month: month, day: day };
	  }

	  createClass(CivilDate, [{
	    key: 'plus',
	    value: function plus$$1(data) {
	      var _plus3 = plus(this, data),
	          year = _plus3.year,
	          month = _plus3.month,
	          day = _plus3.day;

	      return new CivilDate(year, month, day);
	    }
	  }, {
	    key: 'with',
	    value: function _with() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$year = _ref.year,
	          year = _ref$year === undefined ? this.year : _ref$year,
	          _ref$month = _ref.month,
	          month = _ref$month === undefined ? this.month : _ref$month,
	          _ref$day = _ref.day,
	          day = _ref$day === undefined ? this.day : _ref$day;

	      return new CivilDate(year, month, day);
	    }
	  }, {
	    key: 'withTime',
	    value: function withTime() {
	      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CivilDateTime.now().toCivilTime();

	      return new CivilDateTime.from(this, time);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var year = this.year,
	          month = this.month,
	          day = this.day;

	      return pad(year, 4) + '-' + pad(month, 2) + '-' + pad(day, 2);
	    }
	  }, {
	    key: 'toDate',
	    value: function toDate(zone, time) {
	      return this.withTime(date).withZone(zone).toDate();
	    }
	  }, {
	    key: 'year',
	    get: function get$$1() {
	      return this[DATA$2].year;
	    }
	  }, {
	    key: 'month',
	    get: function get$$1() {
	      return this[DATA$2].month;
	    }
	  }, {
	    key: 'day',
	    get: function get$$1() {
	      return this[DATA$2].day;
	    }
	  }], [{
	    key: 'now',
	    value: function now(zone) {
	      return CivilDateTime.now(zone).toCivilDate();
	    }
	  }, {
	    key: 'fromDate',
	    value: function fromDate(date, zone) {
	      return CivilDateTime.fromDate(date, zone).toCivilDate();
	    }
	  }, {
	    key: 'parse',
	    value: function parse$$1(string) {
	      return CivilDateTime.parse(string).toCivilDate();
	    }
	  }]);
	  return CivilDate;
	}();

	/*
	** Copyright (C) 2018 Bloomberg LP. All rights reserved.
	** This code is governed by the license found in the LICENSE file.
	*/

	exports.CivilDate = CivilDate;
	exports.CivilTime = CivilTime;
	exports.CivilDateTime = CivilDateTime;
	exports.Instant = Instant$1;
	exports.ZonedInstant = ZonedInstant;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map
